<script>
  import { Toaster } from "svelte-french-toast";
  import { initClient } from "@urql/svelte";
  import { url } from "./Api/config";
  import { setLinks } from "./Api/congress_stores.js";
  import Fruehstuecksworkshop from "./Container/Fruehstuecksworkshop.svelte";
  import IMKAnmeldung from "./Container/IMKAnmeldung.svelte";
  import IMSpezial from "./Container/IMSpezial.svelte";
  import MyCongressdata from "./Container/MyCongressdata.svelte";
  import Sponsors from "./Container/Sponsors.svelte";
  import Starvortraege from "./Container/Starvortraege.svelte";
  import Wsggo2o from "./Container/Wsggo2o.svelte";

  const path = "/api/congress";

  initClient({
    url: url + path,
  });

  export let congressId;
  export let widgetView;
  export let links;

  setLinks(links);

  const components = {
    fruehstuecksworkshop: Fruehstuecksworkshop,
    imkanmeldung: IMKAnmeldung,
    imspezial: IMSpezial,
    mycongressdata: MyCongressdata,
    sponsors: Sponsors,
    starvortraege: Starvortraege,
    wsggo2o: Wsggo2o,
  };
</script>

<Toaster />
<svelte:component this={components[widgetView]} {congressId} />
